// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqJumpingRopeSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqJumpingRopeSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M4 9V5C4 3.93913 4.42143 2.92172 5.17157 2.17157C5.92172 1.42143 6.93913 1 8 1C9.06087 1 10.0783 1.42143 10.8284 2.17157C11.5786 2.92172 12 3.93913 12 5V19C12 20.0609 12.4214 21.0783 13.1716 21.8284C13.9217 22.5786 14.9391 23 16 23C17.0609 23 18.0783 22.5786 18.8284 21.8284C19.5786 21.0783 20 20.0609 20 19V15"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 12H2V21H6V12Z"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22 3H18V12H22V3Z"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default EqJumpingRopeSVG;
